import { Damage } from '@bdeo-motor/smartphoto-entities';

function cleanEstimationUserFields(estimation: Record<string, unknown>): void {
  const fieldsToClean = ['part_price', 'labour_time', 'strip_assembly', 'paint_time', 'paint_materials', 'part_reference', 'operation'];

  fieldsToClean.forEach((fieldName) => {
    const userField = `${fieldName}_user`;

    if (!(userField in estimation)) {
      return;
    }

    const originalValue = estimation[fieldName];
    const userValue = estimation[userField];

    if (userValue === undefined || userValue === originalValue) {
      delete estimation[userField];
    }
  });
}

function cleanDamageItemUserFields(damageItem: Record<string, unknown>): void {
  const fieldsToClean = ['severity', 'typology'];

  fieldsToClean.forEach((fieldName) => {
    const userField = `${fieldName}_user`;
    const originalValue = damageItem[fieldName];
    const userValue = damageItem[userField];

    if (userField in damageItem && userValue === originalValue && originalValue !== undefined) {
      delete damageItem[userField];
    }
  });
}

function cleanExportedDamageUserFields(
  exportedData: {
    mainDetection?: {
      estimation?: Record<string, unknown>;
      damages?: Array<Record<string, unknown>>;
    };
    otherDetection?: Array<{
      estimation?: Record<string, unknown>;
      damages?: Array<Record<string, unknown>>;
    }>;
  },
  damage?: Damage
): void {
  if (damage && exportedData.mainDetection?.estimation) {
    const estimation = damage.estimation.Estimation;
    const fieldsToRestore = ['part_price', 'labour_time', 'strip_assembly', 'paint_time', 'paint_materials', 'part_reference', 'operation'];
    const mainEstimation = exportedData.mainDetection.estimation;

    fieldsToRestore.forEach((fieldName) => {
      const userField = `${fieldName}_user`;
      const userValue = mainEstimation[userField];
      const internalOriginalValue = estimation[fieldName as keyof typeof estimation] as unknown;
      const internalUserValue = estimation[`${fieldName}_user` as keyof typeof estimation] as unknown;

      if (
        userValue === undefined &&
        internalUserValue !== undefined &&
        internalOriginalValue !== internalUserValue &&
        !damage.estimation.isAutomaticallyUpdated()
      ) {
        mainEstimation[userField] = internalUserValue;
      }
    });
  }

  if (exportedData.mainDetection?.estimation) {
    cleanEstimationUserFields(exportedData.mainDetection.estimation);
  }

  if (exportedData.mainDetection?.damages) {
    exportedData.mainDetection.damages.forEach((damageItem) => {
      cleanDamageItemUserFields(damageItem);
    });
  }

  if (exportedData.otherDetection) {
    exportedData.otherDetection.forEach((other) => {
      if (other.estimation) {
        cleanEstimationUserFields(other.estimation);
      }
      if (other.damages) {
        other.damages.forEach((damageItem) => {
          cleanDamageItemUserFields(damageItem);
        });
      }
    });
  }
}

export function cleanExportedDamage(exportedData: ReturnType<Damage['export']>, damage?: Damage): void {
  cleanExportedDamageUserFields(exportedData, damage);
}

export function cleanExportedDamages(exportedDamages: Array<ReturnType<Damage['export']>>): Array<ReturnType<Damage['export']>> {
  exportedDamages.forEach((exportedData) => {
    cleanExportedDamage(exportedData);
  });
  return exportedDamages;
}

export function cleanDamageRequestItems(
  damages: Array<{
    typology_user?: string;
    severity_user?: string;
    operation_user?: string;
    typology?: string;
    severity?: string;
    operation?: string;
  }>
): void {
  damages.forEach((damage) => {
    if (damage.typology_user === damage.typology && damage.typology !== undefined) {
      delete damage.typology_user;
    }
    if (damage.severity_user === damage.severity && damage.severity !== undefined) {
      delete damage.severity_user;
    }
    if (damage.operation_user === damage.operation && damage.operation !== undefined) {
      delete damage.operation_user;
    }
  });
}
